import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useQuery } from "react-query";

import checkoutImg from "../../assets/img/checkout.png";

import logo from "../../assets/img/Logo_Ebom_14.png";
import { Wallet, initMercadoPago } from "@mercadopago/sdk-react";
import { usePaymentContext } from "../../context/paymentContext";
import { api } from "../../services/api";

const keyPublicMP =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY_PRD
    : process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY ||
      process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY_PRD;

if (keyPublicMP) {
  initMercadoPago(keyPublicMP, { locale: "pt-BR" });
}

export function Payments() {
  const { dataClient, preferenceId } = usePaymentContext();
  const [walletError, setWalletError] = useState("");

  const { data: configures } = useQuery("configures", async () => {
    const response = await api.get("/configures");
    return response.data?.configures;
  });

  const inscriptionValue = Number(
    configures?.value_sale ?? process.env.REACT_APP_INSCRIPTION_VALUE ?? 50
  ).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  return (
    <Box width={["100%", "100%", "70%", "70%"]} mt={3}>
      <Stack
        direction={["column", "column", "column", "row"]}
        width="100%"
        gap={2}
      >
        <Stack flex="1" p={2} gap={2}>
          <Stack gap={1}>
            <Typography variant="h3">Estamos quase la !</Typography>
            <Typography variant="subtitle2">
              Por favor, verifique os seus dados listados ao lado. Confira o
              valor da sua inscrição e, em seguida, clique no botão "Pagar com
              mercado pago".
            </Typography>
            <img src={checkoutImg} alt="checkout" width={"100%"} />
          </Stack>
        </Stack>
        <Stack flex={1} p={2} gap={2}>
          <Paper>
            <Stack gap={2} p={2}>
              <Typography variant="h5">Resumo da compra</Typography>
              <Stack gap={1}>
                <Typography variant="subtitle2">
                  <strong>Nome:</strong> {dataClient?.name_client}
                </Typography>
                <Typography variant="subtitle2">
                  <strong>Email:</strong>
                  {dataClient?.email}
                </Typography>
                <Typography variant="subtitle2">
                  <strong>Telefone:</strong> {dataClient?.phone}
                </Typography>
                <Typography variant="subtitle2">
                  <strong>Igreja:</strong> {dataClient?.name_church}
                </Typography>
              </Stack>
              <Divider orientation="horizontal" flexItem />
              <Stack direction="row" gap={5}>
                <img src={logo} alt="Logo" width={180} />
                <Stack>
                  <Typography variant="subtitle2" mb={1}>
                    <strong>Inscrição Ebom 2026</strong>
                  </Typography>
                  <Typography variant="subtitle2">
                    <strong>Valor:</strong> {inscriptionValue}
                  </Typography>
                </Stack>
              </Stack>
              <Divider orientation="horizontal" flexItem />
              <Stack>
                {preferenceId ? (
                  <>
                    <Wallet
                      initialization={{
                        preferenceId: preferenceId,
                      }}
                      locale="pt-BR"
                      onError={(error) => {
                        console.error("MercadoPago Wallet error:", error);
                        setWalletError(
                          error?.message ||
                            error?.cause ||
                            "Erro ao carregar o Mercado Pago"
                        );
                      }}
                    />
                    {walletError && (
                      <Typography color="error" variant="body2" mt={1}>
                        {walletError}
                      </Typography>
                    )}
                    <Typography variant="caption" color="text.secondary" mt={1}>
                      preferenceId: {preferenceId}
                    </Typography>
                  </>
                ) : (
                  <Typography color="error">
                    Não foi possível carregar o pagamento. Volte e tente novamente.
                  </Typography>
                )}
              </Stack>
            </Stack>
          </Paper>
        </Stack>
      </Stack>
    </Box>
  );
}
